<template>
  <div id="hres6lu">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres6luIndex"
            searchBoxAlias="approve"
            :maxRowspan="maxRowspan.index" 
            :detailEvent="detailEvent"
            :approveEvent="postHres6luSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :currentDtereq="dtereq"
            :currentNumseq="currentNumseq"
            :currentCodempid="codempid"
            :tab2Table="columns[dash.nowLang].detailTab2"
            :tab3Table="columns[dash.nowLang].detailTab3"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :nowLang="dash.nowLang"  />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6lu/mutation-types'
import detail from 'components/hres6lu/detail'
import moment from 'moment'

export default {
  name: 'hres6lu',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres6luColumnsLabels()
    this.receivedHres6luIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6LU_INDEX_DISP,
      detailDisp: types.GET_HRES6LU_DETAIL_DISP,
      maxRowspan: types.GET_HRES6LU_MAX_ROWSPAN,
      columns: types.GET_HRES6LU_COLUMNS,
      labels: types.GET_HRES6LU_LABELS,
      index: types.GET_HRES6LU_INDEX,
      indexSelected: types.GET_HRES6LU_INDEX_SELECTED,
      currentNumseq: types.GET_HRES6LU_CURRENT_NUMSEQ,
      detail: types.GET_HRES6LU_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      this.msgError = ''
      switch (event) {
        case 'edit':
          if (this.indexSelected.numseq) {
            let searchParams = {
              p_codempid: this.indexSelected.codempid,
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.numseq,
              p_dtereqr: this.indexSelected.dtereqr
            }
            this.receivedHres6luDetail(searchParams)
            this.toggle('detail')
          } else {
            this.msgError = 'Please select anyone row.'
          }
          break
        default:
          break
      }
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6LU_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6LU_PAGE,
      receivedHres6luColumnsLabels: types.RECEIVED_HRES6LU_COLUMNS_LABELS,
      receivedHres6luIndex: types.RECEIVED_HRES6LU_INDEX,
      receivedHres6luCurrentNumseq: types.RECEIVED_HRES6LU_CURRENT_NUMSEQ,
      receivedHres6luDetail: types.RECEIVED_HRES6LU_DETAIL,
      postHres6luSendApprove: types.POST_HRES6LU_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?49b73c3f